import { render, staticRenderFns } from "./scrap_batch_dialog.vue?vue&type=template&id=2b9150b1"
import script from "./scrap_batch_dialog.vue?vue&type=script&lang=js"
export * from "./scrap_batch_dialog.vue?vue&type=script&lang=js"
import style0 from "./scrap_batch_dialog.vue?vue&type=style&index=0&id=2b9150b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports